module.exports = __webpack_public_path__ + "img/boxed-bg.b5c5ab66.png";